import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/nik4o/Desktop/New Ver Web/iliqta/node_modules/next/dist/client/app-dir/link.js");
